import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { companyInfo } from '../mockData';
import { MapPin, Clock, Mail, Send } from 'lucide-react';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.name.trim() || !formData.email.trim() || !formData.subject.trim() || !formData.message.trim()) {
      toast.error('Por favor, completa todos los campos requeridos.');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${API}/contact`, formData);
      
      if (response.data.success) {
        toast.success(response.data.message);
        
        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      }
    } catch (error) {
      console.error('Error submitting contact form:', error);
      
      if (error.response && error.response.data && error.response.data.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error('Error al enviar el mensaje. Por favor, inténtalo de nuevo.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="section-contact">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">CONTACTO</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle body-medium">
            ¿Eres futbolista o representas a un club? Contáctanos para conocer cómo podemos ayudarte.
          </p>
        </div>

        <div className="contact-content">
          {/* Contact Info */}
          <div className="contact-info">
            <h3 className="heading-4">Información de Contacto</h3>
            
            <div className="info-item">
              <MapPin size={24} className="info-icon" />
              <div>
                <p className="body-small">{companyInfo.address}</p>
                <p className="body-small">{companyInfo.city}</p>
                <p className="body-small">{companyInfo.province}</p>
              </div>
            </div>

            <div className="info-item">
              <Clock size={24} className="info-icon" />
              <p className="body-small">{companyInfo.schedule}</p>
            </div>

            <div className="info-item">
              <Mail size={24} className="info-icon" />
              <p className="body-small">{companyInfo.email}</p>
            </div>

            {/* Google Maps */}
            <div className="map-container">
              <iframe
                src={companyInfo.googleMapsUrl}
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Elite Internacional Location"
              ></iframe>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <h3 className="heading-4">Envíanos un Mensaje</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name" className="caption">NOMBRE COMPLETO *</label>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  required
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Tu nombre completo"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email" className="caption">EMAIL *</label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="tu@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone" className="caption">TELÉFONO</label>
                <Input
                  id="phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+34 123 456 789"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject" className="caption">ASUNTO *</label>
                <Input
                  id="subject"
                  name="subject"
                  type="text"
                  required
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Motivo de tu consulta"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message" className="caption">MENSAJE *</label>
                <Textarea
                  id="message"
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Cuéntanos cómo podemos ayudarte..."
                  rows={6}
                />
              </div>

              <Button type="submit" className="btn-primary btn-submit" disabled={isSubmitting}>
                {isSubmitting ? 'Enviando...' : 'Enviar Mensaje'}
                <Send size={20} className="btn-icon" />
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;